import React from 'react'
import PrivacyPolicy from '../privacy-policy'

const PrivacyPolicyFr = () => {
    return <PrivacyPolicy languageCode="fr" />
}

export default PrivacyPolicyFr
